import { useContext } from 'react';
import { PriceContext, PriceContextProps } from 'src/providers/PriceContextProvider';

export const usePriceContext = (): PriceContextProps => {
  return useContext(PriceContext);
};
